import type { RealtimeFanout, RealtimeNotifyEvent } from "@gencow/core";

export function createHttpGatewayFanout(deps: {
  notifyGateway?: (event: RealtimeNotifyEvent) => void;
  notifyGatewayAsync?: (event: RealtimeNotifyEvent) => Promise<void>;
}): RealtimeFanout {
  return {
    async notify(event) {
      if (deps.notifyGatewayAsync) {
        await deps.notifyGatewayAsync(event);
        return;
      }
      deps.notifyGateway?.(event);
    },
  };
}
